import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import Button from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import YellowAccentLines from "@SupplyLand/Icons/YellowAccentLines";
import YellowTriangle from "@SupplyLand/Icons/YellowTriangle";
import loadPromoCategoryProducts from "@SupplyLand/Store/Components/CustomPromotions/Handlers/LoadPromoCategoryProducts";
import { CustomState } from "@SupplyLand/Store/Components/CustomPromotions/PromoCategoryReducer";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    titlePosition = "titlePosition",
    groupHeadingSize = "groupHeadingSize",
    groupHeadingColor = "groupHeadingColor",
    selectedCategoryId = "selectedCategoryId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.titlePosition]: string;
        [fields.groupHeadingSize]: number;
        [fields.groupHeadingColor]: string;
        [fields.selectedCategoryId]: string[];
    };
}
interface PromoInfo {
    Name: string;
    Product: ProductDto;
}

const mapStateToProps = (state: CustomState, ownProps: OwnProps) => {
    return {
        products: state.promoCategoryData?.products,
        fields: ownProps.fields,
    };
};

const mapDispatchToProps = {
    loadPromoCategoryProducts,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CategoryDetailPromoCategoriesStyles {
    titleWrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    container?: GridContainerProps;
    promoCategoryItem?: GridItemProps;
    promoCategoryContainer?: GridContainerProps;
    promoCategoryGroup?: InjectableCss;
    innerContainer?: GridContainerProps;
    promoCategoryImageItem?: GridItemProps;
    promoCategoryImageClickable?: ClickablePresentationProps;
    promoCategoryImage?: LazyImageProps;
    promoCategoryNameLinkItem?: GridItemProps;
    promoCategoryNameLink?: LinkPresentationProps;
    promoTitle: InjectableCss;
    promoHeaderContainer: InjectableCss;
    promoHeaderText: InjectableCss;
    promoAccordionSection?: AccordionSectionPresentationProps;
    promoAccordionSectionWrapper?: InjectableCss;
    promoListContainer?: GridContainerProps;
    promoCategorySelection?: InjectableCss;
    iconYellowAccent?: InjectableCss;
    iconYellowAccentCard?: InjectableCss;
    categoryCardWrapper?: InjectableCss;
    toggleIcon?: InjectableCss;
}

const IconYellowAccentCard = styled.div<{}>`
    display: none;
    height: 0px;
`;

export const categoryDetailPromoCategoriesStyles: CategoryDetailPromoCategoriesStyles = {
    container: {
        gap: 0,
    },
    promoCategoryItem: {
        width: [6, 6, 4, 4, 4],
        css: css`
            padding-bottom: 30px;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            flex: 0 1 100%;
            height: 100%;
            margin: auto !important;
        `,
    },
    innerContainer: {
        gap: 0,
    },
    promoCategoryContainer: {
        gap: 20,
        css: css`
            // border: 4px solid #FFD100;
            flex: 1 1 0;
            flex-basis: 50%;
            flex-wrap: wrap;
            padding-bottom: 20px;
        `,
    },
    promoListContainer: {
        gap: 20,
        css: css`
            border: 4px solid #ffd100;
            flex: 1 1 0;
            flex-basis: 50%;
            flex-wrap: wrap;
            padding-botton: 20px;
        `,
    },
    promoCategoryGroup: {
        css: css`
            width: 100%;
        `,
    },
    promoCategoryImageItem: {
        width: [4, 4, 12, 12, 12],
        css: css`
            width: 100%;
            padding: 0 8px 8px 8px;
        `,
    },
    promoCategoryImageClickable: {
        css: css`
            width: 100%;
            height: 100%;
            justify-content: center;
            margin-bottom: 18px;
        `,
    },
    promoCategoryImage: {
        css: css`
            img {
                height: 200px;
                background-color: transparent;
                background: rgba(247, 246, 246, 0.94);
                padding: 0;
                width: 225px;
            }
        `,
    },
    promoCategoryNameLinkItem: {
        width: 12,
        css: css`
            padding-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                ])}
        `,
    },
    promoCategoryNameLink: {
        css: css`
            width: 100%;
        `,
        color: "text.main",
        typographyProps: {
            weight: "bold",
            css: css`
                width: 100%;
                text-align: center;
                word-wrap: break-word;
            `,
        },
    },
    promoTitle: {
        css: css`
            background-color: rgb(0, 0, 0);
            width: 100%;
            text-color: rgb(255, 255, 255);
        `,
    },
    promoHeaderContainer: {
        css: css`
            border: 2px solid rgb(0, 0, 0);
            flex: 1 1 0;
            flex-basis: 50%;
            flex-wrap: wrap;
            padding-botton: 20px;
            background-color: rgb(0, 0, 0);
        `,
    },
    promoHeaderText: {
        css: css`
            font-weight: 700;
            font-size: 60px;
            color: rgb(255, 255, 255);
        `,
    },
    promoAccordionSectionWrapper: {
        css: css`
            border: 4px solid #ffd100;
            margin-bottom: 55px;
        `,
    },
    promoAccordionSection: {
        headerProps: {
            css: css`
                    button {
                        background: ${getColor("white")};
                        border-bottom: 0;
                    },
                    
                `,
        },

        titleTypographyProps: {
            weight: "bold",
            css: css`
                text-transform: uppercase;
                color: red;
                font-size: 35px;
                align-text: center;
            `,
        },
    },
    promoCategorySelection: {
        css: css`
            -moz-border-radius: 15px; //for mozilla support
            -webkit-border-radius: 15px; //for chrome support
            border-radius: 15px;
            background: #ffd100;
            padding-left: 40px;
            padding-right: 40px;
            font-weight: 700;
            font-size: 28px;
            color: rgba(0, 0, 0, 0.94);
            border-radius: 40px;
            padding-top: 5px;
            padding-bottom: 5px;
        `,
    },
    iconYellowAccent: {
        css: css`
            position: relative;
            width: 100%;
            display: block;
            text-align: center;
            padding-top: 10px;
            margin-top: 15px;
        `,
    },
    iconYellowAccentCard: {
        css: css`
            position: relative;
        `,
    },
    categoryCardWrapper: {
        css: css`
        :hover > ${IconYellowAccentCard}{
            display: block;
        },
        `,
    },
    toggleIcon: {
        css: css`
            width: 0;
            height: 0;
            border-left: 17px solid transparent;
            border-right: 17px solid transparent;
            border-top: 34px solid #ffd100;
            float: right;
            position: relative;
            top: -50px;
            transform: rotate(180deg);
            margin-right: 25px;
            :hover {
                cursor: pointer;
            }
        `,
    },
};

const styles = categoryDetailPromoCategoriesStyles;

const getJustifyContent = (position: string) => {
    if (position === "left") {
        return "flex-start";
    }
    if (position === "right") {
        return "flex-end";
    }
    return "center";
};

const TitleWrapper = styled.div<{ position: string }>`
    display: flex;
    width: 100%;
    justify-content: ${({ position }) => getJustifyContent(position)};
    align-content: left;
    padding-top: 0px;
    padding-bottom: 0px;
`;

const PromoHeaderWrapper = styled.div<{}>`
    display: flex;
    width: 100%;
    justify-content: center;
    align-content: left;
    padding-bottom: 10px;
    text-align: center;
`;

const PromoCategoryProducts = ({ id, products, loadPromoCategoryProducts, fields }: Props) => {
    const [promoList, setPromoList] = React.useState<boolean[]>([]);

    const priceCodeDictionary: Record<string, ProductDto[]> = products.reduce(function (
        a: Record<string, ProductDto[]>,
        product: ProductDto,
    ) {
        a[product.priceCode] = a[product.priceCode] || [];
        a[product.priceCode].push(product);
        return a;
    },
    Object.create(null));

    React.useEffect(() => {
        let categoryToLoad = "588d7a5a-1db4-406d-a7f7-b33a001813fc";
        if (products.length === 0) {
            if (fields.selectedCategoryId && fields.selectedCategoryId.length > 0) {
                categoryToLoad = fields.selectedCategoryId[0];
            }
            loadPromoCategoryProducts({ categoryId: categoryToLoad });
        }

        if (promoList.length === 0 && Object.keys(priceCodeDictionary)?.length) {
            const list = new Array(Object.keys(priceCodeDictionary).length).fill(true);
            setPromoList(list);
        }
    });

    const titleText = {
        css: css`
            font-weight: 700;
            font-size: ${fields.groupHeadingSize}px;
            color: ${fields.groupHeadingColor};
            font-family: "Montserrat", sans-serif;
        `,
    };

    const renderGroupHeading = (products: ProductDto[]) => {
        if (products.length > 0) {
            return (
                <TitleWrapper position={fields.titlePosition}>
                    <Typography {...titleText}>{translate(`SwagPage_${products[0].priceCode}`)}</Typography>
                </TitleWrapper>
            );
        }
    };

    const renderProductCard = (products: ProductDto[]) => {
        return products?.map(product => (
            <GridItem key={product.id} {...styles.promoCategoryItem}>
                {product.smallImagePath && (
                    <Clickable href={product.productDetailUrl} {...styles.promoCategoryImageClickable}>
                        <LazyImage src={product.smallImagePath} {...styles.promoCategoryImage} />
                    </Clickable>
                )}
                <Link
                    href={product.productDetailUrl}
                    {...styles.promoCategoryNameLink}
                    data-test-selector={`categoryDetailsPromoProductLink_${product.id}`}
                >
                    {product.shortDescription}
                </Link>
            </GridItem>
        ));
    };

    const productList = [] as PromoInfo[];

    Object.keys(priceCodeDictionary)?.forEach((promo, index) => {
        productList[index] = { Name: promo, Product: priceCodeDictionary[promo][0] };
    });

    const onClickCategorySection = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            <StyledWrapper {...styles.promoHeaderContainer}>
                <Icon {...styles.iconYellowAccent} src={YellowAccentLines} size={40} />
                <PromoHeaderWrapper>
                    <Typography {...styles.promoHeaderText}>{translate("SWAG STORE")}</Typography>
                </PromoHeaderWrapper>
            </StyledWrapper>

            {Object.keys(priceCodeDictionary)?.map((promo, index) => (
                <StyledWrapper key={promo} {...styles.promoAccordionSectionWrapper} id={promo}>
                    <GridContainer key={promo} {...styles.promoCategoryContainer}>
                        <StyledWrapper {...styles.promoCategoryGroup}>
                            <Icon {...styles.iconYellowAccent} src={YellowAccentLines} size={40} />
                            {renderGroupHeading(priceCodeDictionary[promo])}
                            <Icon onClick={onClickCategorySection} src={YellowTriangle} {...styles.toggleIcon}></Icon>
                        </StyledWrapper>
                        {renderProductCard(priceCodeDictionary[promo])}
                    </GridContainer>
                </StyledWrapper>
            ))}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PromoCategoryProducts),
    definition: {
        group: "Common",
        icon: "List",
        isSystem: true,
        fieldDefinitions: [
            {
                name: fields.titlePosition,
                displayName: "Title Position",
                editorTemplate: "DropDownField",
                options: [
                    { value: "center", displayName: "Center" },
                    { value: "left", displayName: "Left" },
                    { value: "right", displayName: "Right" },
                ],
                defaultValue: "center",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                fieldType: "General",
                name: fields.groupHeadingColor,
                editorTemplate: "ColorPickerField",
                displayName: "Group Heading Color",
                defaultValue: "black",
                sortOrder: 3,
            },
            {
                fieldType: "General",
                name: fields.groupHeadingSize,
                editorTemplate: "IntegerField",
                displayName: "Group Heading Size",
                min: 1,
                defaultValue: 20,
                sortOrder: 3,
            },
            {
                fieldType: "General",
                name: fields.selectedCategoryId,
                displayName: "Selected Category",
                editorTemplate: "CategoriesField",
                defaultValue: [],
                singleCategorySelection: item => true,
                sortOrder: 2,
            },
        ],
    },
};

export default widgetModule;

interface CategorySection {
    name: string;
    expanded: boolean;
}
